import * as React from 'react';
import { SkeletonLoader } from '@grandvisionhq/elements';

const ShippingMethodPlaceholder = ()=>{
    return /*#__PURE__*/ React.createElement("div", {
        className: "shipping-method-placeholder",
        role: "presentation"
    }, /*#__PURE__*/ React.createElement(SkeletonLoader, {
        className: "shipping-method-placeholder__method"
    }, /*#__PURE__*/ React.createElement("svg", {
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        height: "48px"
    }, /*#__PURE__*/ React.createElement("rect", {
        width: "200",
        height: "24px",
        rx: "4",
        fill: "currentColor"
    }), /*#__PURE__*/ React.createElement("rect", {
        width: "180",
        height: "16px",
        rx: "4",
        fill: "currentColor",
        y: "32"
    }))), /*#__PURE__*/ React.createElement(SkeletonLoader, {
        className: "shipping-method-placeholder__logo"
    }, /*#__PURE__*/ React.createElement("svg", {
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        height: "24px"
    }, /*#__PURE__*/ React.createElement("rect", {
        width: "24px",
        height: "24px",
        rx: "4",
        fill: "currentColor"
    }))));
};

export { ShippingMethodPlaceholder };
//# sourceMappingURL=ShippingMethodPlaceholder.js.map
